import { atom, useAtomValue } from 'jotai';

import { isWireDownOrWithinReachV3 } from '@dte/otw-azure-functions/src/common/reports/customerReport/symptomsToCallCodeV3/isWireDown';
import { getFilteredReportAnswers } from '@dte/otw-azure-functions/src/report/getQuestion';

import { workingDraftReportWithCurrentStepAtom } from '../../../workingDraftReportWithCurrentStepAtom';

const downWireAtom = atom<boolean>((get) => {
	const report = get(workingDraftReportWithCurrentStepAtom);
	const answers = getFilteredReportAnswers(report);
	const downWire = isWireDownOrWithinReachV3(answers);
	return downWire === true;
});
downWireAtom.debugLabel = 'downWireAtom';

export function useIsDownWire(): boolean {
	return useAtomValue(downWireAtom);
}
